import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ElektraContactForm } from "@/components/forms/ElektraContactForm";

interface ElektraFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  defaultService?: string;
  title?: string;
}

export const ElektraFormModal: React.FC<ElektraFormModalProps> = ({
  isOpen,
  onClose,
  defaultService = "",
  title = "Elektra Aanvraag"
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="sr-only">{title}</DialogTitle>
        </DialogHeader>
        <ElektraContactForm 
          defaultService={defaultService}
          onClose={onClose}
          className="border-0 shadow-none"
        />
      </DialogContent>
    </Dialog>
  );
};